module.exports = __webpack_public_path__ + "static/media/icons8-ms-excel.2d6ff61c.svg";